import React, { useEffect } from 'react'

import { AppFilterPanel, AppPageTabs } from '@components'
import EditMappingDrawer from 'Pages/User/CustomMapping/EditDrawer'
import { MAPPING_TYPE } from 'Pages/User/CustomMapping/@constants'
import CustomMappingTable from 'Pages/User/CustomMapping/Table'
import { clearSignals, selectedMappingTab } from 'Pages/User/CustomMapping/@signals'


// ACRISS and Categories as two tabs, like Manage Settings: the open tab's actions in the band, one table below
const TABS = [
	{ key: MAPPING_TYPE.ACRISS, value: MAPPING_TYPE.ACRISS, label: 'Custom ACRISS' },
	{ key: MAPPING_TYPE.CATEGORY, value: MAPPING_TYPE.CATEGORY, label: 'Custom Categories' },
]

export default function CustomMappingPageContent() {

	useEffect(() => {
		return () => {
			clearSignals()
		}
	}, [])

	return <>
		<AppFilterPanel
			toggles={<AppPageTabs
				tabs={TABS}
				value={selectedMappingTab.value}
				onChange={(_, value) => selectedMappingTab.value = value}
				stackProps={{ sx: { mb: 0 } }}
			/>}
		/>
		<EditMappingDrawer/>
		<CustomMappingTable key={selectedMappingTab.value} path={selectedMappingTab.value}/>
	</>
}
